// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cloud-download"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 17.4003C2.21916 16.4899 1 14.6373 1 12.5C1 9.79943 2.94636 7.55346 5.51282 7.08835C5.72518 3.69029 8.54842 1 12 1C15.4516 1 18.2748 3.69029 18.4872 7.08835C21.0536 7.55346 23 9.79943 23 12.5C23 14.6373 21.7808 16.4899 20 17.4003","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 18L12 22L16 18M12 20.75V11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CloudDownloadIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cloud-download',
    ref,
    icon: element,
  },
));

CloudDownloadIcon.displayName = 'CloudDownloadIcon';

export default CloudDownloadIcon;
